import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { GRAY_400 } from "../../constant/colors";

const CustomInfoCircleOutlined = (props) => {
  return <InfoCircleOutlined style={{ height: "100%", color: GRAY_400, ...props.inputStyles }} />;
};

export default CustomInfoCircleOutlined;
